import React from 'react';
import Layout from '../components/Layout';
import ProfessionalHero from '../components/ProfessionalHero';
import ProfessionalMethodSection from '../components/ProfessionalMethodSection';
import ProfessionalTestimonials from '../components/ProfessionalTestimonials';
import ProfessionalCourseContent from '../components/ProfessionalCourseContent';
import ProfessionalProductSection from '../components/ProfessionalProductSection';
import ProfessionalAboutInstructor from '../components/ProfessionalAboutInstructor';
import ProfessionalGuarantees from '../components/ProfessionalGuarantees';
import PreloadResources from '../components/PreloadResources';

const ProfessionalPage = () => {
  return (
    <>
      <PreloadResources lcpImagePath="/lovable-uploads/6df25097-8673-47ce-94a1-5910bd758cca.png" />
      <Layout>
        <div className="[&_p]:[text-wrap:pretty] [&_h2]:[text-wrap:balance] [&_h3]:[text-wrap:balance]">
        <ProfessionalHero />
        <ProfessionalMethodSection />
        <ProfessionalTestimonials />
        <ProfessionalCourseContent />
        <ProfessionalAboutInstructor />
        <ProfessionalProductSection />
        <ProfessionalGuarantees />
        </div>
      </Layout>
    </>
  );
};

export default ProfessionalPage;